import { StageSchema } from "@core/foundation/stage";
import { z } from "@core/zod";

const EnvSchema = z.object(
  { STAGE: StageSchema },
  { STAGE: "The stage the app is deployed to" },
);

export const env = EnvSchema.parse(process.env);
